
import { Component, Prop, Vue } from 'nuxt-property-decorator'

@Component({ name: 'DesignLogo' })
export default class DesignLogo extends Vue {
  @Prop({ default: () => ({ width: 140, height: 176 }) }) size! : { width : number, height : number }
}
